import { render, staticRenderFns } from "./historial.vue?vue&type=template&id=4bfd7f8e&"
import script from "./historial.vue?vue&type=script&lang=js&"
export * from "./historial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports